import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Page as MineralPage,
  PageProps as MineralPageProps,
} from '@mineral/core';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { FloatingDrawerPosition } from './AppShell';

export interface PageProps extends Omit<MineralPageProps, 'title'> {
  title?: string;
  titleToDisplay?: React.ReactNode;
  helmetTitle?: string;
}

export const Page = ({
  title,
  titleToDisplay,
  sx,
  helmetTitle,
  ...restProps
}: PageProps): React.ReactElement => {
  const [floatingDrawer] = useLocalStorage<FloatingDrawerPosition>(
    'floatingDrawer',
    FloatingDrawerPosition.NONE
  );
  return (
    <>
      <Helmet title={helmetTitle ? helmetTitle : title} />
      <MineralPage
        sx={{
          backgroundColor: 'transparent',
          '& .MnrlPage-header': { display: 'block', pt: 0 },
          '& .MnrlPage-main': {
            zIndex: 2,
            ml:
              floatingDrawer === FloatingDrawerPosition.LEFT ||
              floatingDrawer === FloatingDrawerPosition.NONE
                ? 6
                : 'unset',
            mr: floatingDrawer === FloatingDrawerPosition.RIGHT ? 6 : 'unset',
          },
          ...sx,
        }}
        title={titleToDisplay ? titleToDisplay : title}
        {...restProps}
      />
    </>
  );
};
